import { Component, OnInit } from '@angular/core';
import { trigger, transition, style, animate } from '@angular/animations';
import { Subscription } from 'rxjs/Subscription';
import { Router } from '@angular/router';
import { CustomerSelectItem } from '../../setup-equipment/setup-equipment.model';
import { CompartViewModel, CopyObsPoint, CopyObsPointModel, MeasurementPointsViewModel } from '../model/measurement-points.model';
import { CompartDealerList, DealerSelected, SearchItem, SelectedList } from '../../../entities/search/model';
import { MeasurementPonitsService } from '../services/measurement-points-service';
import { CompartType } from '../../../entities/compart/model';
import { TranslateService } from '../../../translate/translate.service';
import { AppService } from '../../../app.service';
import { LoadingService } from '../../../shared/services/loading.service';
import { SetupEquipmentService } from '../../setup-equipment/setup-equipment.service';
import { SetupModelsService } from '../../setup-models/setup-models.service';
import { UserDealerGroup } from '../../setup-models/setup-models.model';
import { NotificationsService } from 'angular2-notifications';
import { CreateMeasurementPointsComponentComponent } from '../create-measurement-points-component/create-measurement-points-component.component';
import { MatDialog } from '@angular/material/dialog';
import { EditMeasurementPointsComponentComponent } from '../edit-measurement-points-component/edit-measurement-points-component.component';
import { ManageComponentsService } from '../../manage-components/manage-components.service';
import { MakeViewModel, Model } from '../../manage-components/manage-components.model';
import { FavouriteDialogService } from '../../GET_NEW_UI/favourite-dialog/favourite-dialog.service';
import { ModelSelectionFilter } from '../../GET_NEW_UI/favourite-dialog/favourite-dialog-modal';



@Component({
  selector: 'app-measurement-points-admin',
  templateUrl: './measurement-points-admin.component.html',
  styleUrls: ['./measurement-points-admin.component.scss'],
  providers: [MeasurementPonitsService],
  animations: [
    trigger(
      'fadeInOut', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('500ms', style({ opacity: 1 }))
      ]),
      transition(':leave', [
        style({ opacity: 1 }),
        animate('500ms', style({ opacity: 0 }))
      ])
    ]
    )]
})
export class MeasurementPointsAdminComponent implements OnInit {

  componentType: number = 2;
  searchComponentOption = 1;
  selectedCompartTypeId = 0;
  makeList: CustomerSelectItem[] = [];
  modelList: CustomerSelectItem[] = [];
  compoentmodelList: CustomerSelectItem[] = [];
  selectedMakeId = 0;
  selectedModelId = 0;
  disabled = 0;
  private _subscriptions: Subscription[] = [];

  private _userLanguage = 'english';
  compartsWithMPConfiged: CompartViewModel[];
  components: CompartViewModel[];
  allComponentsWithMPConfiged: CompartViewModel[];
  private comSearchItems: SearchItem[] = [];
  UOM: boolean = false;
  compartViewModel: CompartViewModel;
  measurementPoints: MeasurementPointsViewModel[];
  measurementPointsNew: MeasurementPointsViewModel[] = [];
  compartId: number;
  componentTypePlusName: string;
  measurementPointShow: boolean = false;
  CopyObsPointModel: CopyObsPointModel;
  compartForCopy: CompartViewModel[]
  dealergroupId: number;
  SelectedList: SelectedList[] = [];
  compartDealerList: CompartDealerList;
  dealerSelected1: DealerSelected[] = [];
  copyObsType: number;
  selectedModelCopyObsId: number;
  dealergroupCopyObsId: number;
  // filteredModels: CustomerSelectItem[] = [];
  filteredModels: Model[] = [];
  modelsListCopy: Model[] = [];
  MakeViewModel: MakeViewModel[] = [];
  modelLoading: boolean = false;
  compartTypeId: number = 0;
  userDealerGroup: UserDealerGroup[] = [];
  IsComponentTableShow: boolean = false;
  modelTitle: string = "";
  copyCompartId: number = 0;
  private _availableCompartTypes: CompartType[] = [
    { Id: 230, Title: 'Link', Order: 1 },
    { Id: 231, Title: 'Bushing', Order: 2 },
    { Id: 232, Title: 'Shoe', Order: 3 },
    { Id: 233, Title: 'Idler', Order: 5 },
    { Id: 234, Title: 'Carrier Roller', Order: 6 },
    { Id: 235, Title: 'Track Roller', Order: 7 },
    { Id: 236, Title: 'Sprocket', Order: 4 },
    { Id: 237, Title: 'Guard', Order: 8 },
    { Id: 240, Title: 'Track Elongation', Order: 9 },
  ];
  constructor(
    private _translate: TranslateService,
    private _appService: AppService,
    private _loading: LoadingService,
    private _router: Router,
    private _equipmentService: SetupEquipmentService,
    private _measurementPointsService: MeasurementPonitsService,
    private _componentService: ManageComponentsService,
    private _favouriteDialogService: FavouriteDialogService, public _modelService: SetupModelsService, private _notify: NotificationsService, private _dialog: MatDialog,
  ) {
    //  _http.get("Api/Component/getAvailableCompartTypeList").share().map(function (response) { return response.json(); }).catch(this.handleError).subscribe(function (result) { this._availableCompartTypes = result; }, function (error) { this.handleError; }, function () { });




  }
  ngOnInit() {
    this._appService.setPageTitle('Measurement Points');
    if (this.componentType == 1) {
      this.loadAllMakeList();
    } else {
      this._equipmentService.getOEMMakeList().subscribe(result => this.makeList = result);

    }

    this._measurementPointsService.getCompartList().subscribe(result => this._availableCompartTypes = result);

    this._subscriptions.push(this._measurementPointsService.getCompartsWithMeasurementPointsConfiged().subscribe(r => {
      this.compartsWithMPConfiged = r;
    }));
    this.GetUserDealerGroup();
  }



  currentUsingMP() {
    this.searchComponentOption = 1;
  }

  allComponents() {
    this.searchComponentOption = 2;
  }


  compartTypesSelected(selectedCompartId: number) {
    this.selectedCompartTypeId = selectedCompartId;
    this.pushMultipleSelection(14, selectedCompartId);
  }


  makeSelected() {
    this.modelLoading = true;
    this.modelList = [];
    if (this.componentType == 1) {
      this.filteredModels = null

      let makeArray = [];
      let familyArray = [];

      familyArray.push(203)

      makeArray.push(this.selectedMakeId)

      var params: ModelSelectionFilter = {
        Families: familyArray,
        Makes: makeArray
      }
      this._favouriteDialogService.GetModelsAvailable(params).subscribe(r => {
        if (r) {
          this.modelList = r;
          this.modelLoading = false;
        }
      });
    } else {


      this._subscriptions.push(this._equipmentService.getModelList(this.selectedMakeId).subscribe(r => {
        this.modelList = r;
        this.modelLoading = false;
      }));
    }

    this.pushMultipleSelection(5, this.selectedMakeId);
  }

  loadAllModels() {
    this._componentService.getModelListV2().subscribe(result => {
      this.modelsListCopy = result;
      this.filteredModels = result;
    })
  }
  loadRopeShovelModels() {
    this._favouriteDialogService.GetRopeShovelModels(203).subscribe(result => {
      this.modelsListCopy = result;
      this.filteredModels = result;
    })
  }
  modelSelected(selecedModelId: number) {
    this.pushMultipleSelection(6, this.selectedModelId);
  }
  dealerSelected(selecedModelId: number) {
    this.IsComponentTableShow = false;
    this.selectedModelCopyObsId = 0;
    this.compartForCopy = [];
    this.pushMultipleSelection(21, this.dealergroupId);
  }

  pushMultipleSelection(itemId: number, searchId: number): void {
    const index = this.comSearchItems.findIndex(m => m.Id === itemId);
    if (index !== -1) {
      this.comSearchItems.splice(index, 1);
    }
    const item = new SearchItem();
    item.Id = itemId; item.SearchId = searchId;
    this.comSearchItems.push(item);
  }
  popMultipleSelection(itemId: number, searchId: number) {
    if (searchId === 0)
      return;
    const currentSearchItem = this._appService.getSearchItems().find(m => m.Id === itemId);
    if (!currentSearchItem) return;
    const index = this.comSearchItems.findIndex(m => m.Id === itemId && (m.SearchId === searchId));
    if (index < 0) return;
    this.comSearchItems.splice(index, 1);
    //this.resetControlBySearchId(itemId);
  }

  openMeasurementPoints(compartId: number, compartTypeId: number) {
    // this._router.navigate(['/measurement-points', compartId]);
    this.compartId = compartId;
    this.compartTypeId = compartTypeId;
    this.loadMeasurementPoints();
  }



  GetUserDealerGroup() {
    this._modelService.GetUserDealerGroup().subscribe(result => {

      result.forEach(x => {

        this.userDealerGroup.push(x);

      });
    })
  }

  Reset() {
    this.selectedModelId = 0;
    this.selectedMakeId = 0;
    this.selectedCompartTypeId = 0;
    this.components = [];
    this.popMultipleSelection(21, this.dealergroupId);
    this.dealergroupId = 0;

    this.measurementPoints = [];
    this.measurementPointShow = false;
  }


  loadAllMakeList() {
    this.makeList = [];
    this._componentService.GetMakeFromFamily(203).subscribe(result => {
      this.MakeViewModel = result;
      this.MakeViewModel.forEach(x => {
        this.makeList.push({ Id: x.Make_auto, Name: x.Makedesc })
      })

    })
  }
  componnetTypeChange() {
    this.makeList = [];
    if (this.componentType == 1) {
      this.loadAllMakeList();
    } else {
      this._equipmentService.getOEMMakeList().subscribe(result => {
        this.makeList = result;
        this.makeList = this.makeList.filter(x => x.Name != 'PnH');
      }
      );
    }
    this.selectedModelId = null;
    this.selectedMakeId = null;
    this.components = [];
    this.measurementPoints = [];
    this.measurementPointShow = false;
  }
  Search() {
    if (this.selectedMakeId > 0 && this.selectedModelId > 0) {
      this._loading.startLoading();
      this._subscriptions.push(this._measurementPointsService.getFilteredComparts(this.comSearchItems, this.componentType).subscribe(result => {
        this.measurementPoints = null;
        this.measurementPointShow = false;
        this.components = [];
        this.components = result;
        this._loading.finishedLoading();
      }));
    } else {
      this._notify.warn("Please select Make and Model")
    }

  }

  Translate(value: string): string {
    return this._translate.translateToLang(value, this._userLanguage);
  }

  loadMeasurementPoints() {
    this._loading.startLoading();
    let modelid = 0;
    if (this.componentType == 1) {
      modelid = 0;
    } else {
      modelid = this.selectedModelId
    }
    this._subscriptions.push(this._measurementPointsService.getCompartMeasurementPointsNew(+this.compartId, this.dealergroupId, modelid).subscribe(r => {
      this.compartViewModel = r.Compart;

      this.measurementPoints = r.MeasurementPointsViewModels;
      this.componentTypePlusName = r.Compart.CompartType + "(" + r.Compart.CompartName + ")";
      this.measurementPointShow = true;
      this._loading.finishedLoading();
      console.log("measurementPoints", this.measurementPoints)
    }));
  }

  getImage(MPId: number) {
    this._measurementPointsService.GetMeasurementPointImage(MPId).subscribe(res => {
    })
  }
  addMeasurementPoints(compartInfo: CompartViewModel) {
    var lastorder = 0;
    if (this.measurementPoints.length >= 1)
      lastorder = this.measurementPoints[this.measurementPoints.length - 1].Order;
    let createNewMP = this._dialog.open(CreateMeasurementPointsComponentComponent, {
      panelClass: 'removeModalOverflow',
      data: {
        order: lastorder,
        compartId: this.compartId,
        compType: compartInfo.CompartType,
        compName: compartInfo.CompartName,
        typeSelected: this.componentType
      }
    });

    createNewMP.afterClosed().subscribe(createPop => {
      if (createPop == undefined)
        return;
      if (createPop > 0)
        this.loadMeasurementPoints();
    });

  }

  editMeasurementPoints(measurementPoint: MeasurementPointsViewModel) {
    let editMP = this._dialog.open(EditMeasurementPointsComponentComponent, {
      panelClass: 'removeModalOverflow',
      data: {
        compartId: this.compartId,
        measurementPointObj: measurementPoint,
        makeId: this.compartViewModel.MakeId,
      }
    });

    editMP.afterClosed().subscribe(editMP => {
      if (editMP) {
        this.loadMeasurementPoints();
      }
    });
  }

  UpdateMP(point, compartInfo: CompartViewModel) {
    var lastorder = 0;
    if (this.measurementPoints.length >= 1)
      lastorder = this.measurementPoints[this.measurementPoints.length - 1].Order;
    let createNewMP = this._dialog.open(CreateMeasurementPointsComponentComponent, {
      panelClass: 'removeModalOverflow',
      data: {
        order: lastorder,
        compartId: this.compartId,
        existingPoint: point,
        compType: compartInfo.CompartType,
        compName: compartInfo.CompartName,

      }
    });

    createNewMP.afterClosed().subscribe(createPop => {
      if (createPop == undefined)
        return;
      if (createPop > 0)
        this.loadMeasurementPoints();
    });
  }

  changeMeasurementPointStatus(status: boolean, measurement: MeasurementPointsViewModel) {
    if (measurement.isDisabled != status) {
      this._measurementPointsService.changeMeasurementPointStatus(status, measurement.MeasurementPonitId).subscribe(r => {
        if (r.m_Item1 < 0) {
          this._notify.error("Change active status has been unsuccessful");
        }
        else {
          measurement.isDisabled = status;
          this._notify.success("Change active status has been successful");
        }
      });
    }
  }

  ConvertUOM(event: any) {
    console.log("UOM", event.target.value, this.UOM)
    if (this.UOM == true) {
      this.measurementPoints.map(x => {
        x.StartingDim = (x.StartingDim * 25.4)
        x.EndingDim = (x.EndingDim * 25.4)

      })
    } else {
      this.measurementPoints.map(x => {
        x.StartingDim = (x.StartingDim / 25.4)
        x.EndingDim = (x.EndingDim / 25.4)

      })
    }
  }

  // isFirstComponentInList(item, index) {

  //   if (this.measurementPoints.indexOf(item) == 0) {
  //     return true;
  //   }
  //   return false;
  // }

  isFirstComponentInList(item, index) {
    // Check if the next index exists
    if (index == 0) {
      return true; // No next item, so hide
    }
    // Now compare with the next item
    else if (this.measurementPoints[index - 1].WSREType !== this.measurementPoints[index].WSREType) {
      return true;
    } else {
      return false;
    }
  }

  // isLastComponentInList(item, index) {
  //   if (this.measurementPoints.indexOf(item) == this.measurementPoints.length - 1) {
  //     return true;
  //   }
  //   return false;
  // }

  isLastComponentInList(item, index) {

    if (index < this.measurementPoints.length - 1) {
      if (this.measurementPoints[index].WSREType !== this.measurementPoints[index + 1].WSREType) {
        return true;
      }
    }

    return this.measurementPoints.indexOf(item) === this.measurementPoints.length - 1;
  }

  OrderUP(order: number, id: number, name: string) {
    console.log("info.", order, id)
    const index = this.measurementPoints.findIndex(item => item.MeasurementPonitId == id);
    if (index > 0) {
      const previousItem = this.measurementPoints[index - 1];
      this._measurementPointsService.OrderUp_MeasurementPoint(+id, order, +previousItem.MeasurementPonitId, name).subscribe(res => {
        if(res)
          this.loadMeasurementPoints();
      });
    }
  }

  OrderDown(order: number, id: number, name: string) {
    const index = this.measurementPoints.findIndex(item => item.MeasurementPonitId == id);
    if (index >= 0) {
      const previousItem = this.measurementPoints[index + 1];
      this._measurementPointsService.OrderDown_MeasurementPoint(+id, order,previousItem.MeasurementPonitId, name).subscribe(res => {
        if(res)
          this.loadMeasurementPoints();
      });
    }
  }


  OnSelect(measurementPointsViewModel: MeasurementPointsViewModel) {
    if (measurementPointsViewModel != null) {
      this.measurementPointsNew.push(measurementPointsViewModel);
    }
  }

  CopyObsClick() {
    this.showPopup = !this.showPopup;
  }

  showPopup: boolean = false;

  // togglePopup() {
  //   this.showPopup = !this.showPopup;
  //   if (this.showPopup) {
  //     if(this.componentType==1){
  //       this.loadRopeShovelModels();
  //     }else{
  //       this.loadAllModels();
  //     }

  //   }else{
  //     this.copyObsType=0
  //   }
  // }

  changeModelAutoComplete(event: any) {
    if (event.target.value != "") {
      if (event.target.value.length > 2) {
        const filterValue = event.target.value.toLowerCase();
        this.filteredModels = this.modelsListCopy.filter(option => option.Title.toLowerCase().includes(filterValue));
      } else {
        this.filteredModels = this.modelsListCopy;
      }
    } else {
      this.filteredModels = this.modelsListCopy;
    }

  }

  onModelSelected(event: any) {
    let id = this.filteredModels.find(f => f.Title == event.value).Id;
    this.selectedModelCopyObsId = id;
    this.loadComponentByModelId();
    this.dealergroupCopyObsId = 0;
  }

  CopyObsPoint() {
    // Initialize CopyObsPointModel with default values

    this.compartDealerList = {
      compartId: null,
      selectedObsList: []
    };
    let modelArr_ = [];

    if(this.SelectedList.length>0){
      this.SelectedList.forEach(element => {
        element.dealerSelected.map(id => {
          modelArr_.push(id);
          element.dealerSelected = modelArr_;
        }
  
        )
      });
    }else{
      this.measurementPointsNew.forEach(element => {
        this.SelectedList.push({measurementPointId:element.MeasurementPonitId,
          dealerSelected:[],
          measurementPointName: element.Name
        })
      });
    }
    
    this.compartDealerList.compartId = this.compartId;
    this.compartDealerList.selectedObsList = this.SelectedList;

    if(this.measurementPointsNew)

    // this.measurementPointsNew.forEach(x => {
    //   let obsPoint = new CopyObsPoint();   // Create a new CopyObsPoint instance
    //   obsPoint.MeasurementPointId = x.MeasurementPonitId;  // Assign the MeasurementPointId
    //   this.CopyObsPointModel.ObsPoints.push(obsPoint);  // Push the CopyObsPoint instance
    // });
    // if (this.dealergroupCopyObsId > 0) {
    //   this.CopyObsPointModel.CompartId = this.compartId;
    //   this.CopyObsPointModel.ModelId = 0;
    // } else {
    //   this.CopyObsPointModel.CompartId = this.copyCompartId;
    //   this.CopyObsPointModel.ModelId = this.selectedModelCopyObsId;
    // }



    // this.CopyObsPointModel.DealerId = this.dealergroupCopyObsId;
    this._measurementPointsService.CopyObsPoints(this.compartDealerList).subscribe(c => {
      if (c != null) {
        if (c == 1) {

          this.showPopup = false;
          this.IsComponentTableShow = false;
          this.copyCompartId = 0;
          this.compartForCopy = [];
          this.measurementPointsNew = [];
          this.modelTitle = "";
          this.loadMeasurementPoints();
          this.SelectedList = [];
          this._notify.success('Obs Points copy successfully.');
        }

      }
    })
  }

  loadComponentByModelId() {
    console.log(this.compartTypeId)
    this._measurementPointsService.GetComponentsByModel(this.selectedModelCopyObsId, this.compartTypeId).subscribe(result => {
      if (result != null) {
        this.compartForCopy = result;
        this.IsComponentTableShow = true;
      }
    });
  }

  OnSlectComponent(compartid: number) {
    this.copyCompartId = compartid
  }


  loadComponentModelList() {
    this.makeList = [];
    this._equipmentService.GetComponentModel(this.compartId).subscribe(result => {
      this.compoentmodelList = result;

    })
  }

  compartSelected(MeasurementPointId, DealerGroupId: any, name: string) {
    const dealerGroupID = DealerGroupId.value;
    // Skip if DealerGroupId is 0 (Default option)
    if (dealerGroupID === 0) return;
    let existingItem;
    // Find the item with the matching compartId in SelectedList
    if (this.SelectedList.length > 0) {
      existingItem = this.SelectedList.find(item => item.measurementPointId === MeasurementPointId);
    }

    if (existingItem) {
      // Overwrite the dealerSelected array with the latest selected DealerGroupId
      existingItem.dealerSelected = dealerGroupID;
    } else {
      // If no matching compartId is found, create a new entry with the latest selected DealerGroupId
      this.SelectedList.push({
        measurementPointId: MeasurementPointId,
        dealerSelected: dealerGroupID,
        measurementPointName: name
      });
    }
  }

  OnChangeVisibilty(event: any, measurementpointId: number) {
    let isVisible = 0;
    if (event.value == 1) {
      isVisible = 1
    }
    this._componentService.ChangeObsPointVisibility(measurementpointId, isVisible).subscribe(result => {

      if (result != null) {
        this._notify.success('Obs point visibility change successfully');
      }
    })
  }
}
